import { ElementRef, EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import { SRQCompletedService } from '../srq-completed/srq-completed.service';
import { NavbarInukaService } from '../navbar-inuka/navbar-inuka.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TrackerService } from '../../core/tracker/tracker.service';
import { SessionStorageService } from "ngx-webstorage";
import { UserService } from '../../core/user/user.service';
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountService } from '../../core/auth/account.service';
import { QuestionarreAnswerService } from '../questionarre-answer/questionarre-answer.service';
import { WellbeingScanService } from '../wellbeing-scan/wellbeing-scan.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../srq-completed/srq-completed.service";
import * as i2 from "../navbar-inuka/navbar-inuka.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../ng-jhipster/language";
import * as i5 from "../../ng-jhipster/service";
import * as i6 from "../../core/tracker/tracker.service";
import * as i7 from "ngx-webstorage";
import * as i8 from "../../core/user/user.service";
import * as i9 from "@angular/platform-browser";
import * as i10 from "@angular/router";
import * as i11 from "../../core/auth/account.service";
import * as i12 from "../questionarre-answer/questionarre-answer.service";
import * as i13 from "../wellbeing-scan/wellbeing-scan.service";
import * as i14 from "@angular/common";
import * as i15 from "@angular/forms";
import * as i16 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "../../shared/track-user-activity.directive";
import * as i18 from "../wellbeing-scan/wellbeing-start/wellbeing-start-bubbles.component";
function WellbeingResultChartComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 44);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_img_4_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.onSwipeLeft(); });
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_img_26_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 46);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_img_26_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onSwipeRight(); });
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_img_36_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 44);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_img_36_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onSwipeLeft(); });
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_img_54_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 46);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_img_54_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onSwipeRight(); });
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_div_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_ng_template_74_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵelementStart(2, "table", 49);
    i0.ɵɵelementStart(3, "tbody");
    i0.ɵɵelementStart(4, "tr");
    i0.ɵɵelement(5, "td", 50);
    i0.ɵɵelementStart(6, "td", 51);
    i0.ɵɵelement(7, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵelement(9, "td", 53);
    i0.ɵɵelementStart(10, "td", 51);
    i0.ɵɵelement(11, "span", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelement(13, "td", 55);
    i0.ɵɵelementStart(14, "td", 51);
    i0.ɵɵelement(15, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 19);
    i0.ɵɵelementStart(17, "a", 57);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_ng_template_74_Template_a_click_17_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const modal_r24 = restoredCtx.$implicit; return modal_r24.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResultChartComponent_ng_template_76_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵelementStart(2, "table", 49);
    i0.ɵɵelementStart(3, "tbody");
    i0.ɵɵelementStart(4, "tr");
    i0.ɵɵelement(5, "td", 58);
    i0.ɵɵelementStart(6, "td", 51);
    i0.ɵɵelement(7, "span", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵelement(9, "td", 60);
    i0.ɵɵelementStart(10, "td", 51);
    i0.ɵɵelement(11, "span", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelement(13, "td", 62);
    i0.ɵɵelementStart(14, "td", 51);
    i0.ɵɵelement(15, "span", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "tr");
    i0.ɵɵelement(17, "td", 64);
    i0.ɵɵelementStart(18, "td", 51);
    i0.ɵɵelement(19, "span", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 19);
    i0.ɵɵelementStart(21, "a", 57);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_ng_template_76_Template_a_click_21_listener() { const restoredCtx = i0.ɵɵrestoreView(_r29); const modal_r27 = restoredCtx.$implicit; return modal_r27.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { name: a0 }; };
const _c1 = function (a0, a1, a2, a3) { return { name: a0, initialScore: a1, finalScore: a2, sessions: a3 }; };
function WellbeingResultChartComponent_ng_template_78_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelement(1, "h6", 66);
    i0.ɵɵelementStart(2, "h2", 67);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 68);
    i0.ɵɵelementStart(5, "div", 69);
    i0.ɵɵelementStart(6, "div", 70);
    i0.ɵɵelementStart(7, "span", 71);
    i0.ɵɵelement(8, "img", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "wellbeing-start-bubbles");
    i0.ɵɵelement(10, "p", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 70);
    i0.ɵɵelement(12, "p", 73);
    i0.ɵɵelementStart(13, "p");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "p", 74);
    i0.ɵɵelementStart(16, "p");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "p", 75);
    i0.ɵɵelementStart(19, "p");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 76);
    i0.ɵɵelement(22, "wellbeing-start-bubbles");
    i0.ɵɵelement(23, "p", 72);
    i0.ɵɵelement(24, "p", 73);
    i0.ɵɵelementStart(25, "p");
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "p", 74);
    i0.ɵɵelementStart(28, "p");
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "p", 75);
    i0.ɵɵelementStart(31, "p");
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 19);
    i0.ɵɵelementStart(34, "a", 77);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_ng_template_78_Template_a_click_34_listener() { const restoredCtx = i0.ɵɵrestoreView(_r32); const modal_r30 = restoredCtx.$implicit; return modal_r30.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(11, _c0, ctx_r13.person == null ? null : ctx_r13.person.name));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\"", ctx_r13.person == null ? null : ctx_r13.person.testimonial, "\"");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("src", ctx_r13.imagePathSingle, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction4(13, _c1, ctx_r13.person == null ? null : ctx_r13.person.name, ctx_r13.person == null ? null : ctx_r13.person.initialScore, ctx_r13.person == null ? null : ctx_r13.person.finalScore, ctx_r13.person == null ? null : ctx_r13.person.sessions));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.challenge);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.action);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.result);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction4(18, _c1, ctx_r13.person == null ? null : ctx_r13.person.name, ctx_r13.person == null ? null : ctx_r13.person.initialScore, ctx_r13.person == null ? null : ctx_r13.person.finalScore, ctx_r13.person == null ? null : ctx_r13.person.sessions));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.challenge);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.action);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.person == null ? null : ctx_r13.person.result);
} }
function WellbeingResultChartComponent_ng_template_80_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelement(1, "h5", 78);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "h5", 79);
    i0.ɵɵelement(4, "p", 80);
    i0.ɵɵelement(5, "h5", 81);
    i0.ɵɵelement(6, "p", 82);
    i0.ɵɵelement(7, "h5", 83);
    i0.ɵɵelement(8, "p", 84);
    i0.ɵɵelement(9, "h5", 85);
    i0.ɵɵelement(10, "p", 86);
    i0.ɵɵelement(11, "h5", 87);
    i0.ɵɵelement(12, "p", 88);
    i0.ɵɵelementStart(13, "div", 19);
    i0.ɵɵelementStart(14, "a", 77);
    i0.ɵɵlistener("click", function WellbeingResultChartComponent_ng_template_80_Template_a_click_14_listener() { const restoredCtx = i0.ɵɵrestoreView(_r35); const modal_r33 = restoredCtx.$implicit; return modal_r33.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c2 = function () { return { "track": "click", "name": "ss_results_book_session_btn_clicked" }; };
export class WellbeingResultChartComponent {
    constructor(srqService, elementRef, navbarInukaService, modalService, languageService, eventManager, trackerService, sessionStorageService, userService, domSanitizer, router, activatedRoute, accountService, sessionStorage, questionarreAnswerService, wellbeingScanService) {
        this.srqService = srqService;
        this.elementRef = elementRef;
        this.navbarInukaService = navbarInukaService;
        this.modalService = modalService;
        this.languageService = languageService;
        this.eventManager = eventManager;
        this.trackerService = trackerService;
        this.sessionStorageService = sessionStorageService;
        this.userService = userService;
        this.domSanitizer = domSanitizer;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.accountService = accountService;
        this.sessionStorage = sessionStorage;
        this.questionarreAnswerService = questionarreAnswerService;
        this.wellbeingScanService = wellbeingScanService;
        this.onTimeDate = new EventEmitter();
        this.onTotalScore = new EventEmitter();
        this.onPerson = new EventEmitter();
        this.onOrganizationCode = new EventEmitter();
        this.delaPage = 1;
        this.STORIES = {
            en: [
                { "name": "Richard",
                    "testimonial": "I want to deal better with working from home.",
                    "initialScore": 17,
                    "finalScore": 20,
                    "sessions": 4,
                    "challenge": "In principle things are going well, but I constantly work long days behind the screen. Every time I try to make time for myself to really take breaks or turn off the phone at night it just doesn't work out.",
                    "action": "My coach and I tried different strategies: taking breaks, walking outside, meeting with his manager about being apped at night, etc. Finally I hgit up on the strategy that worked for me which was the simple step of including exercising every day before and after work.",
                    "result": "That big stick of my coach, helped me to finally follow through on my own resolution to move at least once a day." },
                { "name": "Afa",
                    "testimonial": "I want to get more out of my week.",
                    "initialScore": 16,
                    "finalScore": 20,
                    "sessions": 2,
                    "challenge": "I feel completely fine. But I do want to add more to the company I work for and take more responsibility.",
                    "action": "In 2 sessions I became clear about what is important to me. I got more control over the completion of tasks, and made sure that this was implemented in my daily life.",
                    "result": "For me it worked well to reserve a time block for unexpected tasks, choose 3 things to focus on in a day, and prioritize sports twice a week above all else. I am much more in a 'flow' now." },
                { "name": "Bert",
                    "testimonial": "In addition to work, I also want time for private life.",
                    "initialScore": 16,
                    "finalScore": 19,
                    "sessions": 6,
                    "challenge": "I'm home late all the time, completely exhausted. I just don't have the energy and time to do the things that are important to me - time with family and friends.",
                    "action": "In 6 sessions I learnt how to set clearer boundaries and make time for family and friends. The sessions helped me sort out what was my priority at work and where I should draw the line.",
                    "result": "By giving priority to friends and family, I got a lot more energy, which strangely enough also made me much happier at work. I wish I had made this change earlier in my life!" },
                { "name": "Shanti",
                    "testimonial": "I want a better relationship with my partner.",
                    "initialScore": 15,
                    "finalScore": 18,
                    "sessions": 3,
                    "challenge": "At work things are fine but my boyfriend and I argue all the time. It's like we never get done with our frustrations.",
                    "action": "In 3 sessions I reflected on my role in the relationship with my coach. We discussed, among other things, the conversation I wanted to have, and also how I would react if my partner went in a “full on attack” again.",
                    "result": "The sessions helped me a lot. I didn't really work it out on my own, but talking about it showed me how important my partner is to me and how I could start a conversation with him." },
                { "name": "Gerard",
                    "testimonial": "I want to live a healthier life.",
                    "initialScore": 17,
                    "finalScore": 20,
                    "sessions": 3,
                    "challenge": "I often get home late and then hit the couch. I don't get around to sports and my hobbies even though I know it's good for me.",
                    "action": "I drew up a sports schedule for myself and really stuck to it with the coach acting as a friendly big stick :-)",
                    "result": "I have been avoiding this for years. It is wonderful that I finally managed to get sports into my routine! Can we schedule an appointment in 6 months to check if I can keep it up?" },
                { "name": "Robin",
                    "testimonial": "Everything that goes wrong annoys me.",
                    "initialScore": 6,
                    "finalScore": 16,
                    "sessions": 7,
                    "challenge": "I constantly see how things can improve, and it is difficult to let go or give responsibilities to others. I want to be able to let go and not worry so much.",
                    "action": "In 7 sessions I worked to clarify what is important to me and learnt to focus on it. I learnt how to transfer knowledge, got more self-insight and found someone with similar experiences to spar with. After that I got more done with the team and am now more satisfied.",
                    "result": "I now realize it's normal to struggle with some things, and I now know how to fix it. I'm so proud that I have helped my colleagues to work much more independently." },
                { "name": "Sandra",
                    "testimonial": "I feel like I'm on my own.",
                    "initialScore": 6,
                    "finalScore": 17,
                    "sessions": 5,
                    "challenge": "I really tiptoe all the time. When things go wrong I feel responsible for iteven if it's not because of me. I can't talk about it with my supervisor. I also have trouble falling asleep at night.",
                    "action": "In conversations with my coach, I realized that I'm not the only one struggling with the workload and friction with colleagues. I discovered specific activities I could do when stress was high, such as walking, listening to music, meditating. I also found a way to discuss what was bothering me with my manager.",
                    "result": "I now have a toolkit for when my stress gets too high. My manager was very understanding and his recognition of my stress and talking about it turned out to be very helpful." },
                { "name": "Patricia",
                    "testimonial": "I am completely done with Corona.",
                    "initialScore": 4,
                    "finalScore": 16,
                    "sessions": 6,
                    "challenge": "Due to corona I have to work differently. I have a friend in a coma for 1.5 weeks because of corona. All this is really intense. Normally I have quite a bit of time in the evening, but now work and stress overflows and I can't turn it off. I just want to go back to normal.",
                    "action": "I was literally able to “lose my shit” in sessions and get my thoughts straight. I started taking a 15 minute walk every night to turn off. I also established connection with s colleague to exchange tips & tricks.",
                    "result": "I am dealing with the current situation better now. It was comforting to know that this situation also bothered others so much. I found it empowering to actually name the fear." },
                { "name": "Maria",
                    "testimonial": "I want to sleep better.",
                    "initialScore": 7,
                    "finalScore": 15,
                    "sessions": 4,
                    "challenge": "I don't get done what I would like to do every day. I'm just not sharp and feel tired. I don't sleep well. I find myself on my phone or watching TV late into the night. Sometimes I drink to fall asleep. If I don't I often lie awake in bed for a long time.",
                    "action": "My coach and I first discussed what was bothering me. We made a list of what did work for me to fall asleep, which I tried out one by one. I also made more contact with a friend, slowed down at work and took a week away. All these actions helped me a lot.",
                    "result": "What I mainly learned was to define what I wanted to do in small, concrete ways, instead of getting stuck in vague ambitions. I asked for support from my supervisor which was super nice. I have more rest now." },
                { "name": "Alex",
                    "testimonial": "I have a lot of work pressure.",
                    "initialScore": 7,
                    "finalScore": 16,
                    "sessions": 5,
                    "challenge": "I have constant stress due to high work pressure and the unpredictability of my work. Lots of different projects with deadlines, and I find it hard to say no. I really feel on the verge of burnout.",
                    "action": "In 5 sessions, Alex was given the space to focus on what he had been planning to do for a year by taking small steps (i.e. making a to-do list to get my head in order); set more boundaries, manage your schedule more tightly, exercise more. But this time to really do it, instead of having it as a goal.",
                    "result": "I notice that I actually go very well, even when it is very hectic at work now. I now set my boundaries much more clearly." },
                { "name": "Stephan",
                    "testimonial": "My organization and manager gives me stress.",
                    "initialScore": 3,
                    "finalScore": 16,
                    "sessions": 3,
                    "challenge": "I am so frustrated. I feel like my supervisor and organization is changing direction all the time, has unrealistic expectations, is controlling and frankly doesn't allow me to do my job properly.",
                    "action": "In 3 sessions, I became clear on what is important to me: more autonomy and recognition. I also had two conversations with my supervisor to share this.",
                    "result": "I have found some peace of my own in the storm. And while my supervisor and I will never be friends, at least he understands me and tries a little more to make it work for both of us. I feel more relaxed and can concentrate more on my work." },
                { "name": "Stef",
                    "testimonial": "Above all, I want to do it very well.",
                    "initialScore": 3,
                    "finalScore": 14,
                    "sessions": 5,
                    "challenge": "I want to be there for everyone and be a good colleague and I find it difficult to indicate that things are actually not going so well.",
                    "action": "In 5 sessions I looked at what was important to me. This helped me to make better choices for myself and my own health.",
                    "result": "I now keep my own boundaries and start a conversation with others when things aren't going well. I try to be less hard on myself and give myself more slack now." }
            ],
            nl: [
                { "name": "Richard",
                    "testimonial": "Ik wil beter met thuiswerken omgaan.",
                    "initialScore": 17,
                    "finalScore": 20,
                    "sessions": 4,
                    "challenge": "In principe gaat het goed, maar ik maak lange dagen constant achter dat scherm en elke keer als ik afspraken met mezelf maak om toch écht elke dag pauzes te nemen of de telefoon uit te zetten's avonds komt het er niet van.",
                    "action": "Richard en z'n coach probeerden verschillende strategieën uit: pauzes, buiten wandelen, afspreken met zijn manager over ge-appt worden's avonds, etc. Richard hield de strategieën over die voor hem werkten; o.a. elke dag bewegen vóór en na werk.",
                    "result": "Die stok achter de deur van mijn coach, hielp om eindelijk mijn eigen voornemen om 1x per dag te gaan bewegen ook echt te doen." },
                { "name": "Afa",
                    "testimonial": "Ik wil meer uit mijn week halen.",
                    "initialScore": 16,
                    "finalScore": 20,
                    "sessions": 2,
                    "challenge": "Ik voel me best oké. Ik zou me willen concentreren om meer uit mijn week te halen en mijn doelen sneller te bereiken.",
                    "action": "In 2 sessies heeft zij helder gekregen wat belangrijk is voor haar: meer controle over het afronden van taken, en ervoor gezorgd dat dit in haar dagelijks leven werd geïmplementeerd.",
                    "result": "Voor mij werkt het goed om een tijdsblok te reserveren voor onverwachte taken, 3 dingen te kiezen om op die dag te focussen en sport twee keer per week boven alles te prioriteren. Ik zit nu veel meer in een 'flow'." },
                { "name": "Bert",
                    "testimonial": "Ik wil naast werk ook tijd voor privé.",
                    "initialScore": 16,
                    "finalScore": 19,
                    "sessions": 6,
                    "challenge": "Ik ben de hele tijd laat thuis, helemaal uitgeput. Ik heb gewoon geen energie en tijd om de dingen te doen die voor mij belangrijk zijn: tijd met familie en vrienden.",
                    "action": "In 6 sessies duidelijker grenzen stellen en tijd voor familie en vrienden inruimen. Tijdens de sessies kreeg hij op een rijtje wat voor hem prioriteit had, op werk, en waar hij de grens het beste kon leggen. Een van zijn stappen was dat hij een blok tijd in zijn agenda zette voor vrienden.",
                    "result": "Door vrienden en gezin voorrang te geven, krijg ik veel meer energie, wat vreemd genoeg ook betekent dat ik veel lekkerder aan het werk ben. Ik wou dat ik deze verandering eerder in mijn leven had aangebracht!" },
                { "name": "Shanti",
                    "testimonial": "Ik wil een betere relatie met mijn partner.",
                    "initialScore": 15,
                    "finalScore": 18,
                    "sessions": 3,
                    "challenge": "Op werk gaat het prima maar mijn vriend en ik ruziën aan een stuk door soms. Het is alsof we het nooit uitgepraat krijgen.",
                    "action": "In 3 sessies spiegelde Shanti met haar coach over hoe zij in de relatie stond. Ze spraken o.a. het gesprek dat Shanti wilde hebben met haar vriendin door, en ook hoe Shanti zou reageren als haar vriendin weer “vol in de aanval” zou gaan.",
                    "result": "De sessies hebben mij ontzettend geholpen in elk geval. Je komt er niet echt uit in je eentje, maar door erover te praten zag ik hoe belangrijk hij voor me is, en hoe ik het gesprek met hem aan kon gaan." },
                { "name": "Gerard",
                    "testimonial": "Ik wil gezonder leven.",
                    "initialScore": 17,
                    "finalScore": 20,
                    "sessions": 3,
                    "challenge": "Ik ben vaak laat thuis en plof dan op de bank. Ik kom niet aan sporten en mijn hobbies toe. Terwijl ik weet hoe goed het is voor me.",
                    "action": "In 3 sessies een sportschema opstellen voor zichzelf, en zich daar ook echt aan houden (met de coach als stok achter de deur).",
                    "result": "Ik liep hier al jaren mee, heerlijk dat ik nu eindelijk ook sport echt in mijn routine heb weten te krijgen! Kunnen we over 6 maanden een afspraak inplannen om te checken of ik het wel volhoud?" },
                { "name": "Robin",
                    "testimonial": "Ik erger me aan alles wat er misgaat.",
                    "initialScore": 6,
                    "finalScore": 16,
                    "sessions": 7,
                    "challenge": "Ik zie constant hoe dingen kunnen verbeteren, en het is moeilijk om los te laten of verantwoordelijkheden aan anderen te geven. Ik wil kunnen loslaten en me niet zoveel zorgen maken.",
                    "action": "In 7 sessies werkte Robin eraan om duidelijk te krijgen wat voor hem belangrijk is en daarop te focussen: kennis overdragen, meer zelfinzicht krijgen, sparren met iemand met vergelijkbare ervaringen. Daarna kreeg hij meer gedaan met het team en was meer tevreden.",
                    "result": "Ik realiseer me nu dat het normaal is om met sommige dingen te worstelen, en ik weet hoe ik het moet oplossen. Als ik dat voel, kan ik dit. En ik heb mijn collega's geholpen om veel zelfstandiger te werken." },
                { "name": "Sandra",
                    "testimonial": "Ik voel me alsof ik alleen ben.",
                    "initialScore": 6,
                    "finalScore": 17,
                    "sessions": 5,
                    "challenge": "Ik loop heel de tijd op mijn tenen. Als er iets misgaat, voel ik me er verantwoordelijk voor, ook al is het niet door mijzelf. Ik kan er niet over praten met mijn leidinggevende. Ik heb ook moeite om's nachts in slaap te vallen.",
                    "action": "In gesprekken met mijn coach realiseerde ik me dat ik niet de enige ben die worstelt met de werkdruk en frictie met collega's. Ik ontdekte specifieke activiteiten die ik kon doen als de stress hoog was, zoals wandelen, naar muziek luisteren, mediteren. Ik vond ook een manier om met mijn manager te bespreken wat mij dwars zat.",
                    "result": "Ik heb nu een toolkit voor als mijn stress te hoog wordt. Mijn manager was erg begripvol en zijn herkenning van mijn stress en het erover praten bleek erg behulpzaam." },
                { "name": "Patricia",
                    "testimonial": "Ik ben helemaal klaar met Corona.",
                    "initialScore": 4,
                    "finalScore": 16,
                    "sessions": 6,
                    "challenge": "Door corona moet ik anders werken, en een vriend van me ligt erdoor al 1,5 week in coma. Dat is echt heftig. Normaal heb ik's avonds ook best wel tijd maar nu vloeit werk daarin over omdat ik het niet uit kan zetten. Ik wil gewoon weer naar normaal.",
                    "action": "Patricia kon in de sessies haar “shit kwijt” en haar gedachten op een rijtje krijgen. Ze ging elke avond 15 minuten te wandelen om werk echt af te sluiten. Ze ging ook bellen met een collega om tips & trucs uit te wisselen.",
                    "result": "Ja ik ga er nu wel beter mee om. Was fijn om te weten dat anderen er ook zoveel last van hadden. En om de angst te benoemen." },
                { "name": "Maria",
                    "testimonial": "Ik wil beter slapen.",
                    "initialScore": 7,
                    "finalScore": 15,
                    "sessions": 4,
                    "challenge": "Ik krijg niet gedaan wat ik zou willen doen elke dag en ben gewoon niet scherp, moe. Ik slaap vrij slecht. Ik zit laat's avonds nog op mijn telefoon of tv te kijken, soms drink ik om in slaap te kunnen vallen. Vaak lig ik in bed nog lang wakker.",
                    "action": "Maria en de coach bespraken eerst wat Maria dwarszat, en maakten toen een lijst van wat wél werkt voor Maria om in slaap te vallen, die ze één voor één uit ging proberen. Meer contact met een vriendin, iets rustiger aan doen op werk en een week ertussenuit hielpen ook een hoop.",
                    "result": "Wat ik vooral geleerd heb was om wat wilde doen heel klein en concreet te maken, ipv in vage ambities te blijven hangen. De steun van mijn leidinggevende was ook erg fijn. Ik heb nu meer rust." },
                { "name": "Alex",
                    "testimonial": "Ik ervaar veel werkdruk.",
                    "initialScore": 7,
                    "finalScore": 16,
                    "sessions": 5,
                    "challenge": "Ik heb constante stress door te hoge werkdruk en de onvoorspelbaarheid van mijn werk. Veel verschillende projecten met deadlines, en ik vind het moeilijk om nee te zeggen. Ik voel me echt op het randje van burnout.",
                    "action": "In 5 sessies heeft Alex door kleine stapjes te zetten (d.w.z. een to-do lijst maken om mijn hoofd op orde te krijgen) de ruimte gekregen om te concentreren op wat hij al een jaar van plan was te gaan doen; meer grenzen stellen, agenda strakker beheren, meer sporten. Maar het dit keer ook écht te doen, ipv het als doel te hebben.",
                    "result": "Ik merk dat ik eigenlijk erg lekker ga, zelfs terwijl het nu erg hectisch is op het werk. Ik zet nu mijn grenzen veel duidelijker." },
                { "name": "Stephan",
                    "testimonial": "Mijn leidinggevende en organisatie geven me stress.",
                    "initialScore": 3,
                    "finalScore": 16,
                    "sessions": 3,
                    "challenge": "Ik ben zo gefrustreerd. Ik heb het gevoel dat mijn leidinggevende en organisatie de hele tijd van richting verandert, onrealistische verwachtingen heeft, controlerend is en me eerlijk gezegd niet toestaat mijn werk goed te doen.",
                    "action": "In 3 sessies kreeg Stephan voor zichzelf duidelijk wat belangrijk is: meer autonomie en herkenning, en hij had hij twee gesprekken met zijn leidinggevende om dit te delen.",
                    "result": "Ik heb'n beetje m'n eigen rust in de storm gevonden. En hoewel mijn leidinggevende en ik nooit vrienden zullen zijn, begrijpt hij me tenminste en probeert hij wat meer om het voor ons allebei te laten werken. Ik voel me meer ontspannen en kan me meer op mijn werk concentreren." },
                { "name": "Stef",
                    "testimonial": "Ik wil het vooral heel goed doen.",
                    "initialScore": 3,
                    "finalScore": 14,
                    "sessions": 5,
                    "challenge": "Ik wil er voor iedereen zijn, en een goede collega zijn en ik vind het lastig om aan te geven dat het eigenlijk niet zo goed gaat.",
                    "action": "In 5 sessies gekeken naar wat belangrijk was voor hem, zodat hij beter voor zichzelf en zijn eigen gezondheid kan kiezen.",
                    "result": "Ik probeer mijn eigen grenzen te bewaren en ga met anderen het gesprek aan als het even niet gaat. Ik probeer minder hard voor mezelf te zijn en me ook te gunnen wat ik nodig heb." }
            ]
        };
    }
    ngOnInit() {
        this.organizationCode = this.sessionStorageService.retrieve('organizationCode');
        if (this.accountService.isAuthenticated()) {
            let queryParameter = parseInt(this.activatedRoute.snapshot.queryParamMap.get('scanId'), 10);
            this.srqHistorySubscription = this.srqService.srqHistory().subscribe((res) => {
                this.srqHistory = res.body || [];
                let srqIndex;
                if (queryParameter) {
                    srqIndex = this.srqHistory.findIndex((s) => s.id === queryParameter);
                }
                this.processParameters(srqIndex);
                this.questionarreAnswerService.findAnswer17BySrqId(this.srqHistory[this.srqHistoryLastIndex].id).subscribe((a) => {
                    this.q17Answer = a.body;
                }, () => {
                    console.log('get q17 answer error');
                });
            });
            this.userServiceSubscription = this.userService.current().subscribe(user => {
                this.currentUser = user;
            });
        }
        else {
            const answers = this.wellbeingScanService.getSavedSrqAnswers();
            if (answers != null) {
                this.questionarreAnswerService.calculateWellbeingScan(answers).subscribe((srq) => {
                    this.showSrqResult(srq.body);
                }, () => {
                    console.log('calculate srq result error');
                });
            }
        }
        this.eventManager.subscribe('langKeyChanged', () => this.updateParameters());
        this.safeManon = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/LDKRT6vqMWc');
    }
    ngOnChanges(changes) { this.updateParameters(); }
    processParameters(srqIndex) {
        this.srqHistoryIndex = srqIndex != null ? srqIndex : this.srqHistory.length - 1;
        this.srqHistoryLastIndex = this.srqHistory.length - 1;
        this.showSrqResult(this.srqHistory[this.srqHistoryIndex]);
    }
    showSrqResult(srqResult) {
        this.displayedTestResult = srqResult;
        this.updateParameters();
    }
    updateParameters() {
        if (!this.displayedTestResult) {
            return;
        }
        this.stories = this.STORIES[this.languageService.getCurrentLanguage()];
        if (!this.stories)
            this.stories = this.STORIES['en'];
        this.totalScore = this.displayedTestResult.score;
        console.log(this.displayedTestResult);
        this.determineBodyStage(this.displayedTestResult);
        this.determineMoodStage(this.displayedTestResult);
        this.determineEnergyStage(this.displayedTestResult);
        this.determinePurposeStage(this.displayedTestResult);
        this.determineTotalScoreStage(this.totalScore);
        this.dateTakenFormatted = this.displayedTestResult.dateTaken.format('D ');
        this.onTimeDate.emit(this.displayedTestResult.dateTaken);
        this.percentTotalScore = this.totalScore * 5;
        this.normalized20 = 20 * 100 / this.percentTotalScore;
        this.normalized70 = 70 * 100 / this.percentTotalScore;
        this.percentBodyScore = this.displayedTestResult.bodyScore * (100 / 6);
        this.percentMoodScore = this.displayedTestResult.moodScore * (100 / 4);
        this.percentEnergyScore = this.displayedTestResult.energyScore * (100 / 6);
        this.percentOutlookScore = this.displayedTestResult.outlookScore * (100 / 4);
        if (this.totalScore > 13) {
            this.resilientClass = 's-resilient-details';
            this.atRiskClass = '';
            this.toughPlaceClass = '';
            this.detailsText = 'resilientDetailsText';
            this.categoriesText = 'resilientCategoriesText';
            this.stories = this.stories.filter(s => s.initialScore > 13);
            this.imagePath = 'content/images/wellbeing/resilient-three.png';
            this.imagePathSingle = 'content/images/wellbeing/resilient-single.png';
            this.progressBackgroundColors = 'linear-gradient(to right, #b793a9 ' + this.normalized20 + '%, #e8d78b ' + this.normalized20 + '%, #e8d78b ' + this.normalized70 + '%, #87c3b4 ' + this.normalized70 + '%, #87c3b4 ' + this.percentTotalScore + '%)';
            this.numberBackgroundColor = '#46a28c';
            this.resilientBorder = '2px solid #87c3b4';
            this.atRiskBorder = '';
            this.toughPlaceBorder = '';
        }
        else if (this.totalScore > 3) {
            this.resilientClass = '';
            this.atRiskClass = 's-at-risk-details';
            this.toughPlaceClass = '';
            this.detailsText = 'atRiskDetailsText';
            this.categoriesText = 'atRiskCategoriesText';
            this.stories = this.stories.filter(s => s.initialScore > 3 && s.initialScore <= 13);
            this.imagePath = 'content/images/wellbeing/at-risk-three.png';
            this.imagePathSingle = 'content/images/wellbeing/at-risk-single.png';
            this.progressBackgroundColors = 'linear-gradient(to right, #b793a9 ' + this.normalized20 + '%, #e8d78b ' + this.normalized20 + '%,  #e8d78b ' + this.percentTotalScore + '%)';
            this.numberBackgroundColor = '#dcc24e';
            this.resilientBorder = '';
            this.atRiskBorder = '2px solid #e8d78b';
            this.toughPlaceBorder = '';
        }
        else {
            this.resilientClass = '';
            this.atRiskClass = '';
            this.toughPlaceClass = 's-in-a-bad-place-details';
            this.detailsText = 'toughPlaceDetailsText';
            this.categoriesText = 'toughPlaceCategoriesText';
            this.stories = this.stories.filter(s => s.initialScore <= 3);
            this.imagePath = 'content/images/wellbeing/tough-place-three.png';
            this.imagePathSingle = 'content/images/wellbeing/tough-place-single.png';
            this.progressBackgroundColors = '#b793a9';
            this.numberBackgroundColor = '#90597b';
            this.resilientBorder = '';
            this.atRiskBorder = '';
            this.toughPlaceBorder = '2px solid #b793a9';
        }
        this.person = this.stories[Math.floor(Math.random() * this.stories.length)];
        this.onPerson.emit(this.person);
        this.onTotalScore.emit(this.totalScore);
    }
    onSwipeLeft() {
        this.srqHistoryIndex--;
        this.updateParameters();
    }
    onSwipeRight() {
        this.srqHistoryIndex++;
        this.updateParameters();
    }
    onDisplayDetailsText() { return 'wellBeingResult.paragraph.' + this.detailsText; }
    onDisplayCategoriesText() { return 'wellBeingResult.paragraph.' + this.categoriesText; }
    displayInfo(content, activityName) {
        this.modalService.open(content).result.then((result) => console.log(result));
        if (activityName)
            this.trackerService.sendActivity(activityName);
    }
    getSupport() {
        this.trackerService.sendActivity("dela_scanresult_booksession_btn_clicked");
        this.router.navigate(['../session/schedule-session']);
    }
    getPerson(person) { this.person = person; }
    ngOnDestroy() {
        if (this.srqHistorySubscription) {
            this.srqHistorySubscription.unsubscribe();
        }
    }
    determineTotalScoreStage(totalScore) {
        this.isAtRisk = false;
        this.isAtTough = false;
        this.isResilient = false;
        if (totalScore <= 3) {
            this.isAtTough = true;
        }
        else if (totalScore >= 4 && totalScore <= 13) {
            this.isAtRisk = true;
        }
        else if (totalScore >= 14) {
            this.isResilient = true;
        }
    }
    determineBodyStage(testResult) {
        if (testResult.bodyScore <= 2) {
            this.bodyStage = 'danger';
        }
        else if (testResult.bodyScore >= 3 && testResult.bodyScore <= 4) {
            this.bodyStage = 'warning';
        }
        else if (testResult.bodyScore >= 5) {
            this.bodyStage = 'success';
        }
        else {
            this.bodyStage = '';
        }
    }
    determineEnergyStage(testResult) {
        if (testResult.energyScore <= 2) {
            this.energyStage = 'danger';
        }
        else if (testResult.energyScore >= 3 && testResult.energyScore <= 4) {
            this.energyStage = 'warning';
        }
        else if (testResult.energyScore >= 5) {
            this.energyStage = 'success';
        }
        else {
            this.energyStage = '';
        }
    }
    determineMoodStage(testResult) {
        if (testResult.moodScore <= 1) {
            this.moodStage = 'danger';
        }
        else if (testResult.moodScore === 2) {
            this.moodStage = 'warning';
        }
        else if (testResult.moodScore >= 3) {
            this.moodStage = 'success';
        }
        else {
            this.moodStage = '';
        }
    }
    determinePurposeStage(testResult) {
        if (testResult.outlookScore <= 1) {
            this.purposeStage = 'danger';
        }
        else if (testResult.outlookScore === 2) {
            this.purposeStage = 'warning';
        }
        else if (testResult.outlookScore >= 3) {
            this.purposeStage = 'success';
        }
        else {
            this.purposeStage = '';
        }
    }
}
WellbeingResultChartComponent.ɵfac = function WellbeingResultChartComponent_Factory(t) { return new (t || WellbeingResultChartComponent)(i0.ɵɵdirectiveInject(i1.SRQCompletedService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.NavbarInukaService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.JhiLanguageService), i0.ɵɵdirectiveInject(i5.JhiEventManager), i0.ɵɵdirectiveInject(i6.TrackerService), i0.ɵɵdirectiveInject(i7.SessionStorageService), i0.ɵɵdirectiveInject(i8.UserService), i0.ɵɵdirectiveInject(i9.DomSanitizer), i0.ɵɵdirectiveInject(i10.Router), i0.ɵɵdirectiveInject(i10.ActivatedRoute), i0.ɵɵdirectiveInject(i11.AccountService), i0.ɵɵdirectiveInject(i7.SessionStorageService), i0.ɵɵdirectiveInject(i12.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i13.WellbeingScanService)); };
WellbeingResultChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingResultChartComponent, selectors: [["wellbeing-result-chart"]], outputs: { onTimeDate: "onTimeDate", onTotalScore: "onTotalScore", onPerson: "onPerson", onOrganizationCode: "onOrganizationCode" }, features: [i0.ɵɵNgOnChangesFeature], decls: 82, vars: 72, consts: [[1, "mt-3"], [1, "row", "equal-distance-h"], ["class", "swipe-arrow", "src", "../../../../content/images/inuka/swipe-left.png", "role", "button", 3, "click", 4, "ngIf"], ["class", "swipe-arrow", "style", "visibility: hidden;", 4, "ngIf"], ["role", "button", 1, "score-board-details", "mb-2", "mt-1", 3, "click"], [2, "text-transform", "capitalize"], ["ngDefaultControl", "", "jhiTranslate", "wellBeingResult.button.toughPlace", 3, "ngModel", "ngModelChange"], ["ngDefaultControl", "", "jhiTranslate", "wellBeingResult.button.atRisk", 3, "ngModel", "ngModelChange"], ["ngDefaultControl", "", "jhiTranslate", "wellBeingResult.button.resilient", 3, "ngModel", "ngModelChange"], ["role", "button", 1, "row", 2, "position", "relative", "display", "flex", "justify-content", "space-around", "font-weight", "bold", "font-size", "20px", 3, "click"], [2, "font-size", "16px", "margin-top", "3px"], [1, "progress", "progress-bar-horizontal"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100"], ["title", "4", 1, "vertical-bar", "threshold-4"], ["title", "14", 1, "vertical-bar", "threshold-14"], [1, "number-circle"], ["class", "swipe-arrow", "src", "../../../../content/images/inuka/swipe-right.png", "role", "button", 3, "click", 4, "ngIf"], [1, "mt-2"], [1, "category-text", 3, "jhiTranslate"], [2, "text-align", "center"], ["role", "button", "routerLink", "/session/schedule-session", "jhiTranslate", "wellBeingResult.button.bookASession", 1, "btn-2", "btn-primary", "find-coach", 3, "trackUserActivity"], [1, "mt-5"], ["jhiTranslate", "wellBeingResult.scoreDetailsTitle", 1, "title", "mb-4"], ["role", "button", 3, "click"], [1, "progress", "progress-bar-vertical"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.body", 1, "category-header"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.mood", 1, "category-header"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.energy", 1, "category-header"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.purpose", 1, "category-header"], ["jhiTranslate", "wellBeingResult.paragraph.filledGraphs", 1, "under-image-text"], [1, "mt-4"], [1, "category-text", 3, "jhiTranslate", "click"], [1, "d-md-none", "mt-3"], ["jhiTranslate", "wellBeingResult.read", 1, "title", "mt-3", "mb-4", 3, "translateValues"], ["role", "button", 1, "person-story", "mb-4", 2, "font-style", "normal!important", "font-weight", "bold!important", "text-decoration", "none!important", 3, "click"], [2, "display", "block", "text-align", "center", "margin-bottom", "20px"], [3, "src"], ["jhiTranslate", "wellBeingResult.paragraph.fourSessions", 1, "under-image-text"], ["jhiTranslate", "wellBeingResult.paragraph.readOurPiece"], ["role", "button", "routerLink", "/index-user", "jhiTranslate", "wellBeingResult.button.inukaHome", 1, "btn-2", "btn-primary", "inuka-home"], ["wellbeingInfoModal", ""], ["categoryInfoModal", ""], ["storyModal", ""], ["coachSessionInfoModal", ""], ["src", "../../../../content/images/inuka/swipe-left.png", "role", "button", 1, "swipe-arrow", 3, "click"], [1, "swipe-arrow", 2, "visibility", "hidden"], ["src", "../../../../content/images/inuka/swipe-right.png", "role", "button", 1, "swipe-arrow", 3, "click"], [1, "modal-body", 2, "overflow-wrap", "break-word"], [2, "display", "block", "margin", "0 auto"], ["align", "center", 1, "score-board-details", "mb-2", 2, "background-color", "white"], ["jhiTranslate", "inukaNgApp.indexUser.resilient", 1, "score-details", "align-middle", "resilient-indicator"], [1, "category-text"], ["jhiTranslate", "inukaNgApp.indexUser.resilientText"], ["jhiTranslate", "inukaNgApp.indexUser.atRisk", 1, "score-details", "align-middle", "at-risk-indicator"], ["jhiTranslate", "inukaNgApp.indexUser.atRiskText"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlace", 1, "score-details", "align-middle", "tough-place-indicator"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlaceText"], ["role", "button", "jhiTranslate", "inukaNgApp.indexUser.done", 1, "btn-2", "btn-primary", "find-coach", 2, "width", "30%!important", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.body", 1, "category-details", "align-middle"], ["jhiTranslate", "inukaNgApp.indexUser.bodyText"], ["jhiTranslate", "inukaNgApp.indexUser.mood", 1, "category-details", "align-middle"], ["jhiTranslate", "inukaNgApp.indexUser.moodText"], ["jhiTranslate", "inukaNgApp.indexUser.energy", 1, "category-details", "align-middle"], ["jhiTranslate", "inukaNgApp.indexUser.energyText"], ["jhiTranslate", "inukaNgApp.indexUser.purpose", 1, "category-details", "align-middle"], ["jhiTranslate", "inukaNgApp.indexUser.purposeText"], ["jhiTranslate", "wellBeingResult.story", 1, "title", 3, "translateValues"], [1, "person-story", 2, "color", "black!important", "text-decoration", "none!important"], [1, "d-none", "d-lg-block"], [1, "row"], [1, "col-6"], [2, "display", "block", "text-align", "center"], ["jhiTranslate", "wellBeingResult.progress", 2, "padding-top", "10px", "text-align", "center", 3, "translateValues"], ["jhiTranslate", "wellBeingResult.myChallenge", 2, "font-weight", "bold"], ["jhiTranslate", "wellBeingResult.whatIdid", 2, "font-weight", "bold"], ["jhiTranslate", "wellBeingResult.myResult", 2, "font-weight", "bold"], [1, "d-lg-none"], ["role", "button", "jhiTranslate", "inukaNgApp.indexUser.done", 1, "btn-2", "btn-primary", "find-coach", 2, "width", "30%!important", "color", "white!important", 3, "click"], ["jhiTranslate", "wellBeingResult.coachesAndSession", 1, "title"], ["jhiTranslate", "wellBeingResult.sessionBasics", 1, "title", 2, "font-weight", "normal"], ["jhiTranslate", "wellBeingResult.paragraph.sessionBasicsText"], ["jhiTranslate", "wellBeingResult.sessionStructure", 1, "title", 2, "font-weight", "normal"], ["jhiTranslate", "wellBeingResult.paragraph.sessionStructureText"], ["jhiTranslate", "wellBeingResult.coachesWhoCare", 1, "title", 2, "font-weight", "normal"], ["jhiTranslate", "wellBeingResult.paragraph.coachesWhoCareText"], ["jhiTranslate", "wellBeingResult.inukaMethod", 1, "title", 2, "font-weight", "normal"], ["jhiTranslate", "wellBeingResult.paragraph.inukaMethodText"], ["jhiTranslate", "wellBeingResult.clientRating", 1, "title", 2, "font-weight", "normal"], ["jhiTranslate", "wellBeingResult.paragraph.clientRatingText"]], template: function WellbeingResultChartComponent_Template(rf, ctx) { if (rf & 1) {
        const _r36 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵtemplate(4, WellbeingResultChartComponent_img_4_Template, 1, 0, "img", 2);
        i0.ɵɵtemplate(5, WellbeingResultChartComponent_div_5_Template, 2, 0, "div", 3);
        i0.ɵɵelementStart(6, "div");
        i0.ɵɵelementStart(7, "table", 4);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_table_click_7_listener() { i0.ɵɵrestoreView(_r36); const _r8 = i0.ɵɵreference(75); return ctx.displayInfo(_r8, "ss_results_edu_score_clicked"); });
        i0.ɵɵelementStart(8, "tbody");
        i0.ɵɵelementStart(9, "tr", 5);
        i0.ɵɵelementStart(10, "td", 6);
        i0.ɵɵlistener("ngModelChange", function WellbeingResultChartComponent_Template_td_ngModelChange_10_listener($event) { return ctx.toughPlaceClass = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "td", 7);
        i0.ɵɵlistener("ngModelChange", function WellbeingResultChartComponent_Template_td_ngModelChange_11_listener($event) { return ctx.atRiskClass = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "td", 8);
        i0.ɵɵlistener("ngModelChange", function WellbeingResultChartComponent_Template_td_ngModelChange_12_listener($event) { return ctx.resilientClass = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r36); const _r8 = i0.ɵɵreference(75); return ctx.displayInfo(_r8, "ss_results_edu_score_clicked"); });
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵelementStart(15, "span");
        i0.ɵɵtext(16, "0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵelementStart(18, "div", 12);
        i0.ɵɵelement(19, "div", 13);
        i0.ɵɵelement(20, "div", 14);
        i0.ɵɵelementStart(21, "div", 15);
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 10);
        i0.ɵɵelementStart(24, "span");
        i0.ɵɵtext(25, "20");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, WellbeingResultChartComponent_img_26_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(27, WellbeingResultChartComponent_div_27_Template, 2, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(28, "br");
        i0.ɵɵelementStart(29, "div", 17);
        i0.ɵɵelement(30, "p", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 19);
        i0.ɵɵelement(32, "a", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 21);
        i0.ɵɵelement(34, "h6", 22);
        i0.ɵɵelementStart(35, "div", 1);
        i0.ɵɵtemplate(36, WellbeingResultChartComponent_img_36_Template, 1, 0, "img", 2);
        i0.ɵɵtemplate(37, WellbeingResultChartComponent_div_37_Template, 2, 0, "div", 3);
        i0.ɵɵelementStart(38, "div", 23);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_div_click_38_listener() { i0.ɵɵrestoreView(_r36); const _r10 = i0.ɵɵreference(77); return ctx.displayInfo(_r10, "ss_results_edu_details_clicked"); });
        i0.ɵɵelementStart(39, "div", 24);
        i0.ɵɵelement(40, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(41, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 23);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_div_click_42_listener() { i0.ɵɵrestoreView(_r36); const _r10 = i0.ɵɵreference(77); return ctx.displayInfo(_r10, "ss_results_edu_details_clicked"); });
        i0.ɵɵelementStart(43, "div", 24);
        i0.ɵɵelement(44, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(45, "div", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 23);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_div_click_46_listener() { i0.ɵɵrestoreView(_r36); const _r10 = i0.ɵɵreference(77); return ctx.displayInfo(_r10, "ss_results_edu_details_clicked"); });
        i0.ɵɵelementStart(47, "div", 24);
        i0.ɵɵelement(48, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(49, "div", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 23);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_div_click_50_listener() { i0.ɵɵrestoreView(_r36); const _r10 = i0.ɵɵreference(77); return ctx.displayInfo(_r10, "ss_results_edu_details_clicked"); });
        i0.ɵɵelementStart(51, "div", 24);
        i0.ɵɵelement(52, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(53, "div", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(54, WellbeingResultChartComponent_img_54_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(55, WellbeingResultChartComponent_div_55_Template, 2, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 19);
        i0.ɵɵelement(57, "p", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "div", 30);
        i0.ɵɵelementStart(59, "p", 31);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_p_click_59_listener() { i0.ɵɵrestoreView(_r36); const _r14 = i0.ɵɵreference(81); return ctx.displayInfo(_r14, "ss_results_edu_inuka_coach_clicked"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 19);
        i0.ɵɵelement(61, "a", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(62, "div", 32);
        i0.ɵɵelement(63, "h6", 33);
        i0.ɵɵelementStart(64, "h6", 34);
        i0.ɵɵlistener("click", function WellbeingResultChartComponent_Template_h6_click_64_listener() { i0.ɵɵrestoreView(_r36); const _r12 = i0.ɵɵreference(79); return ctx.displayInfo(_r12, "ss_results_edu_bottom_block_clicked"); });
        i0.ɵɵtext(65);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "span", 35);
        i0.ɵɵelement(67, "img", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "div", 19);
        i0.ɵɵelement(69, "p", 37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(70, "div");
        i0.ɵɵelement(71, "p", 38);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(72, "div", 19);
        i0.ɵɵelement(73, "a", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(74, WellbeingResultChartComponent_ng_template_74_Template, 18, 0, "ng-template", null, 40, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(76, WellbeingResultChartComponent_ng_template_76_Template, 22, 0, "ng-template", null, 41, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(78, WellbeingResultChartComponent_ng_template_78_Template, 35, 23, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(80, WellbeingResultChartComponent_ng_template_80_Template, 15, 0, "ng-template", null, 43, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex <= 0);
        i0.ɵɵadvance(5);
        i0.ɵɵclassMapInterpolate1("score-details align-middle ", ctx.toughPlaceClass, "");
        i0.ɵɵproperty("ngModel", ctx.toughPlaceClass);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("score-details align-middle ", ctx.atRiskClass, "");
        i0.ɵɵproperty("ngModel", ctx.atRiskClass);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("score-details align-middle ", ctx.resilientClass, "");
        i0.ɵɵproperty("ngModel", ctx.resilientClass);
        i0.ɵɵadvance(6);
        i0.ɵɵclassMapInterpolate3("progress-bar ", ctx.resilientClass, " ", ctx.atRiskClass, " ", ctx.toughPlaceClass, "");
        i0.ɵɵstyleProp("width", ctx.percentTotalScore + "%");
        i0.ɵɵattribute("aria-valuenow", ctx.percentTotalScore);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.totalScore);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex < ctx.srqHistoryLastIndex);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex >= ctx.srqHistoryLastIndex);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("jhiTranslate", ctx.onDisplayDetailsText());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(68, _c2));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex <= 0);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate3("progress-bar ", ctx.resilientClass, " ", ctx.atRiskClass, " ", ctx.toughPlaceClass, "");
        i0.ɵɵstyleProp("height", ctx.percentBodyScore + "%");
        i0.ɵɵattribute("aria-valuenow", ctx.percentBodyScore);
        i0.ɵɵadvance(4);
        i0.ɵɵclassMapInterpolate3("progress-bar ", ctx.resilientClass, " ", ctx.atRiskClass, " ", ctx.toughPlaceClass, "");
        i0.ɵɵstyleProp("height", ctx.percentMoodScore + "%");
        i0.ɵɵattribute("aria-valuenow", ctx.percentMoodScore);
        i0.ɵɵadvance(4);
        i0.ɵɵclassMapInterpolate3("progress-bar ", ctx.resilientClass, " ", ctx.atRiskClass, " ", ctx.toughPlaceClass, "");
        i0.ɵɵstyleProp("height", ctx.percentEnergyScore + "%");
        i0.ɵɵattribute("aria-valuenow", ctx.percentEnergyScore);
        i0.ɵɵadvance(4);
        i0.ɵɵclassMapInterpolate3("progress-bar ", ctx.resilientClass, " ", ctx.atRiskClass, " ", ctx.toughPlaceClass, "");
        i0.ɵɵstyleProp("height", ctx.percentOutlookScore + "%");
        i0.ɵɵattribute("aria-valuenow", ctx.percentOutlookScore);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex < ctx.srqHistoryLastIndex);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistoryIndex >= ctx.srqHistoryLastIndex);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("jhiTranslate", ctx.onDisplayCategoriesText());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(69, _c2));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(70, _c0, ctx.person == null ? null : ctx.person.name));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("\"", ctx.person == null ? null : ctx.person.testimonial, "\"");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("src", ctx.imagePath, i0.ɵɵsanitizeUrl);
    } }, directives: [i14.NgIf, i15.DefaultValueAccessor, i16.JhiTranslateDirective, i15.NgControlStatus, i15.NgModel, i10.RouterLinkWithHref, i17.TrackUserActivityDirective, i18.WellbeingStartBubblesComponent], styles: [".score-board-details[_ngcontent-%COMP%]{background-color:#f8f7f2;border-radius:4rem;border-spacing:.4rem;border-collapse:separate;margin:auto 0}.equal-distance-h[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.equal-distance-v[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-direction:column}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:8px;background-color:#fff;text-transform:uppercase;border-radius:100%;font-weight:bold;color:#f8f7f2;text-align:center}.category-details[_ngcontent-%COMP%]{width:4rem;height:4rem;background-color:#fff;text-transform:uppercase;border-radius:100%;border:1px solid #000;font-size:10px;font-weight:bold;color:#000;text-align:center}.swipe-arrow[_ngcontent-%COMP%]{width:2rem;height:2rem;margin:auto 0}.progress-bar-horizontal[_ngcontent-%COMP%]{width:80%;text-align:center;margin-top:8px;z-index:130}.progress-bar-horizontal-dela[_ngcontent-%COMP%]{width:100%;text-align:center;z-index:130;border-radius:8px}.progress-bar[_ngcontent-%COMP%]{z-index:120}.progress-bar-vertical[_ngcontent-%COMP%]{z-index:130;margin-bottom:5px}.progress-bar-vertical[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:20px 20px 0 0 !important}.vertical-bar[_ngcontent-%COMP%]{height:20px;z-index:110}.number-circle[_ngcontent-%COMP%]{width:16px;height:16px;padding-top:8px;text-align:center;color:#fff}.category-header[_ngcontent-%COMP%]{color:#000;text-transform:uppercase;text-align:center;font-size:.5rem}.find-coach[_ngcontent-%COMP%]{font-size:12px;background-color:#000 !important;color:#fff !important;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.inuka-home[_ngcontent-%COMP%]{font-size:12px;background-color:#fff !important;color:#000 !important;border-color:#000 !important;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.title[_ngcontent-%COMP%]{text-transform:uppercase;color:#000;text-decoration:none !important}.person-story[_ngcontent-%COMP%]{color:#44a38c;font-style:italic;font-weight:lighter;-webkit-text-decoration:underline dotted #44a38c;text-decoration:underline dotted #44a38c;text-align:center;font-size:1.4rem}.under-image-text[_ngcontent-%COMP%]{font-size:9px;font-style:italic;margin-top:10px}.s-resilient-details[_ngcontent-%COMP%]{background-color:#a9d3c7;color:#000}.s-at-risk-details[_ngcontent-%COMP%]{background-color:#efe199;color:#000}.s-in-a-bad-place-details[_ngcontent-%COMP%]{background-color:#b894aa;color:#000}.s-resilient-trend[_ngcontent-%COMP%]{background-color:#a9d3c7;color:#fff}.s-at-risk-trend[_ngcontent-%COMP%]{background-color:#ead88c;color:#fff}.s-in-a-bad-place-trend[_ngcontent-%COMP%]{background-color:#b894aa;color:#fff}.dela-category-header[_ngcontent-%COMP%]{margin:5px 5px 5px 2px;padding:5px;text-transform:uppercase;font-weight:bold;border-radius:5px;line-height:38px}.journey-table[_ngcontent-%COMP%]{width:100%;margin-bottom:1rem;color:#212529}.journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:center}.journey-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6}.journey-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%]{border-top:2px solid #dee2e6}.journey-table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#fff;background-color:#343a40;border-color:#454d55}.journey-table[_ngcontent-%COMP%]   .thead-light[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.journey-table[_ngcontent-%COMP%]{border-collapse:collapse !important}.journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:#fff !important}.journey-table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:inherit;border-color:#dee2e6}.journey-row-icon[_ngcontent-%COMP%]{width:30px !important;text-align:left;vertical-align:center}.journey-row-header[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:#000;padding-left:3px !important;font-size:18px;font-weight:bold}.journey-row-header-dela[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:#000;font-size:16px;font-weight:bold}.journey-row-text[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:gray;padding-left:3px !important;font-size:14px}.vertical-line[_ngcontent-%COMP%]{background-color:#4ab197;width:2px;height:100%;margin-left:calc(50% - 1px)}.score-bubble[_ngcontent-%COMP%]{width:2.5rem;height:2.5rem;border-radius:50%;line-height:2.5rem;text-align:center;z-index:10}.default-icon-text[_ngcontent-%COMP%]{background-color:#fff;color:#4ab197;border:2px solid #4ab197;font-weight:bold}.empty-td[_ngcontent-%COMP%]{border-top:1px dashed #dee2e6}.iframe-container[_ngcontent-%COMP%]{position:relative;overflow:hidden;width:100%;padding-top:56.25%;font-size:14px}.responsive-iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;border:1px solid gray}.blob-text[_ngcontent-%COMP%]{font-size:2rem}.category-header[_ngcontent-%COMP%]{font-size:.5rem}.category-text[_ngcontent-%COMP%]{font-size:.7rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}.blob-text[_ngcontent-%COMP%]{font-size:1rem}@media(min-width: 576px){.category-header[_ngcontent-%COMP%]{font-size:.5rem}.category-text[_ngcontent-%COMP%]{font-size:.7rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}}@media(min-width: 768px){.category-header[_ngcontent-%COMP%]{font-size:.39rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:2.8rem;height:2.8rem;font-size:9px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:1.8rem}}@media(min-width: 992px){.category-header[_ngcontent-%COMP%]{font-size:.44rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3.5rem;border-spacing:.35rem}.score-details[_ngcontent-%COMP%]{width:2.8rem;height:2.8rem;font-size:9px}.swipe-arrow[_ngcontent-%COMP%]{width:1.6rem;height:1.6rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.2rem}}@media(min-width: 1200px){.category-header[_ngcontent-%COMP%]{font-size:.49rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:4rem;border-spacing:.4rem}.score-details[_ngcontent-%COMP%]{width:3.5rem;height:3.5rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:2rem;height:2rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}}"] });
